module.exports = __webpack_public_path__ + "static/media/mastercard.4557829e.svg";